import { createReducer, on } from '@ngrx/store';
import { ResetStateFromRouter } from 'src/app/shared/actions/eliqua.actions';
import { CreateNewIntegration } from '../actions/integration-management-create-new.actions';
import {
  AddEmptyConfSet,
  AddEmptySenderEmail,
  AddEmptySenderName,
  ConfSetsChange,
  EditSesIntegrationSystem,
  LookBackDaysSesChange,
  NameSesChange,
  RemoveConfSet,
  RemoveSenderEmail,
  RemoveSenderName,
  SaveSesConfigurationFailed,
  SaveSesConfigurationSuccess,
  SenderEmailsChange,
  SenderNamesChange,
  SesSubmitData,
  StatusSesChange,
  ToggleCampaignReportingHelpTextStatus,
  ToggleIntegrationConfHelpTextStatus,
  UpdateSesConfigurationSuccess,
} from '../actions/ses-configuration.actions';

export interface SesConfigurationState {
  nameSes: string;
  isActiveSes: boolean;
  showUpdateBtn: boolean;
  showCancelBtn: boolean;
  disableName: boolean;
  integrationConfHelpTextStatus: boolean;
  isSubmittedData: boolean;
  lookBackDaysSes: number | null;
  campaignReportingHelpTextStatus: boolean;
  senderNamesSes: string[];
  senderEmailAddressesSes: string[];
  configurationSetsSes: string[];
}

const initialState: SesConfigurationState = {
  nameSes: '',
  isActiveSes: false,
  showUpdateBtn: false,
  showCancelBtn: false,
  disableName: false,
  integrationConfHelpTextStatus: false,
  isSubmittedData: false,
  lookBackDaysSes: 0,
  campaignReportingHelpTextStatus: false,
  senderNamesSes: [''],
  senderEmailAddressesSes: [''],
  configurationSetsSes: [''],
};

export const SesConfigurationReducer = createReducer(
  initialState,
  on(NameSesChange, (state, { nameSes }) => ({
    ...state,
    nameSes,
  })),
  on(StatusSesChange, (state, { isActiveSes }) => ({
    ...state,
    isActiveSes,
  })),
  on(ToggleIntegrationConfHelpTextStatus, (state) => ({
    ...state,
    integrationConfHelpTextStatus: !state.integrationConfHelpTextStatus,
  })),
  on(LookBackDaysSesChange, (state, { lookBackDaysSes }) => ({
    ...state,
    lookBackDaysSes,
  })),
  on(ToggleCampaignReportingHelpTextStatus, (state) => ({
    ...state,
    campaignReportingHelpTextStatus: !state.campaignReportingHelpTextStatus,
  })),
  on(CreateNewIntegration, () => ({
    ...initialState,
  })),
  on(SesSubmitData, (state) => ({
    ...state,
    isSubmittedData: true,
  })),
  on(SenderNamesChange, (state, { index, value }) => {
    const updatedNames = [...state.senderNamesSes];
    updatedNames[index] = value;
    return { ...state, senderNamesSes: updatedNames };
  }),
  on(AddEmptySenderName, (state) => ({
    ...state,
    senderNamesSes: [...state.senderNamesSes, ''],
  })),
  on(RemoveSenderName, (state, { index }) => ({
    ...state,
    senderNamesSes: state.senderNamesSes.filter((_, i) => i !== index),
  })),
  on(SenderEmailsChange, (state, { index, value }) => {
    const updatedEmails = [...state.senderEmailAddressesSes];
    updatedEmails[index] = value;
    return { ...state, senderEmailAddressesSes: updatedEmails };
  }),
  on(AddEmptySenderEmail, (state) => ({
    ...state,
    senderEmailAddressesSes: [...state.senderEmailAddressesSes, ''],
  })),
  on(RemoveSenderEmail, (state, { index }) => ({
    ...state,
    senderEmailAddressesSes: state.senderEmailAddressesSes.filter((_, i) => i !== index),
  })),
  on(ConfSetsChange, (state, { index, value }) => {
    const updatedConfSets = [...state.configurationSetsSes];
    updatedConfSets[index] = value;
    return { ...state, configurationSetsSes: updatedConfSets };
  }),
  on(AddEmptyConfSet, (state) => ({
    ...state,
    configurationSetsSes: [...state.configurationSetsSes, ''],
  })),
  on(RemoveConfSet, (state, { index }) => ({
    ...state,
    configurationSetsSes: state.configurationSetsSes.filter((_, i) => i !== index),
  })),
  on(SaveSesConfigurationSuccess, (state, { res }) => ({
    ...state,
    showUpdateBtn: true,
    disableName: true,
    nameSes: res.payload.data.integrationConfig.integrationDisplayName,
    isActiveSes: res.payload.data.deleted,
    senderNamesSes: res.payload.data.integrationConfig.senderNames,
    senderEmailAddressesSes: res.payload.data.integrationConfig.senderEmailAddresses,
    configurationSetsSes: res.payload.data.integrationConfig.configurationSets,
    lookBackDays: res.payload.data.integrationConfig.campaignReportingConfiguration.lookbackDays,
    integrationConfHelpTextStatus: false,
    campaignReportingHelpTextStatus: false,
    isSubmittedData: false,
  })),
  on(EditSesIntegrationSystem, (state, { sesData }) => ({
    ...state,
    nameSes: sesData.integrationConfig.integrationDisplayName,
    isActiveSes: sesData.deleted,
    senderNamesSes: sesData.integrationConfig.senderNames,
    senderEmailAddressesSes: sesData.integrationConfig.senderEmailAddresses,
    configurationSetsSes: sesData.integrationConfig.configurationSets,
    lookBackDaysSes: sesData.integrationConfig.campaignReportingConfiguration.lookbackDays,
    showUpdateBtn: true,
    disableName: true,
    showCancelBtn: true,
    isSubmittedData: false,
  })),
  on(SaveSesConfigurationFailed, (state) => ({
    ...state,
    showUpdateBtn: false,
    disableName: false,
  })),
  on(UpdateSesConfigurationSuccess, (state, { res }) => ({
    ...state,
    nameSes: res.payload.data.integrationConfig.integrationDisplayName,
    isActiveSes: res.payload.data.deleted,
    senderNamesSes: res.payload.data.integrationConfig.senderNames,
    senderEmailAddressesSes: res.payload.data.integrationConfig.senderEmailAddresses,
    configurationSetsSes: res.payload.data.integrationConfig.configurationSets,
    lookBackDays: res.payload.data.integrationConfig.campaignReportingConfiguration.lookbackDays,
    integrationConfHelpTextStatus: false,
    campaignReportingHelpTextStatus: false,
    showUpdateBtn: true,
    disableName: true,
  })),
  on(ResetStateFromRouter, () => ({
      ...initialState
  }))
);
